import { ReactElement } from "react";
import { KTSVG } from "../../../_metronic/helpers";

interface IProps {
  title: ReactElement;
  id: string;
  content: ReactElement;
  width?: string;
  maxWidth?: string;
}

export const Drawer = (props: IProps) => {
  return (
    <div
      id={props.id + "_drawer"}
      className="bg-body border border-1 border-gray-600 side-drawer"
      data-kt-drawer="true"
      data-kt-drawer-name={props.id}
      data-kt-drawer-activate="true"
      data-kt-drawer-overlay="true"
      data-kt-drawer-width={props.width || "{default:'100vw', 'sm': '100vw', 'md': '525px'}"}
      data-kt-drawer-direction="end"
      data-kt-drawer-toggle={"#" + props.id}
      data-kt-drawer-close={"#" + props.id + "_drawer_close"}
      style={{ zIndex: 2000000, maxWidth: props.maxWidth}}
    >
      {/* begin::Card */}
      <div className="card shadow-none border-none w-100">
        {/* begin::Header */}
        <div
          className="row card-header"
          style={{ flexWrap: "nowrap", margin: "0" }}
          id="kt_help_header"
        >
          {props.title}

          <div
            className="card-title fw-bold text-gray-600 col-2"
            style={{ justifyContent: "flex-end" }}
          >
            <button
              type="button"
              className="btn btn-sm btn-icon explore-btn-dismiss"
              id={props.id + "_drawer_close"}
              aria-label="Close drawer"
              title="Close drawer"
            >
              <KTSVG
                path="/media/icons/duotune/arrows/arr061.svg"
                className="svg-icon-2"
              />
            </button>
          </div>
        </div>

        {/* end::Header */}

        {/* begin::Body */}
        <div className="card-body p-2 p-md-6" id={props.id + "_body"}>
          {props.content}
        </div>
        {/* end::Body */}
      </div>
      {/* end::Card */}
    </div>
  );
};
